import { SupermarketService } from "@/clients/services/SupermarketService";
import { QueryKeys } from "@/constants/query-keys";
import { useQuery } from "@tanstack/react-query";

export const useGetSupermarketOptions = () => {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: [QueryKeys.SUPERMARKET_OPTIONS],
    queryFn: async () => {
      const { data } =
        await SupermarketService.getSupermarketOptionsApiV1SupermarketsOptionsGet();
      return data.supermarketOptions ?? [];
    },
  });
  return {
    options: data,
    isLoading,
    isError,
    error,
  };
};
